export default "__VITE_ASSET__BTX00fDm__"